import ConfirmationModal from "components/ConfirmationModal";
import DocumentViewerModal from "components/DocumentViewer";
import { StatusChip } from "components/StatusChip";
import { useTranslation } from "contexts/i18nContext";
import { useToast } from "contexts/ToastContext";
import { useHasRole } from "contexts/AuthContext";
import { useState } from "react";
import { editComplaint } from "services/prosecutorDecipilineService";
import { Complaints, Investigation } from "types";
import {
  COMPLIANT_STATUS,
  FEEDBACK_TYPE,
  INVESTIGATION_STATUS,
} from "utils/constantValues";
import { ADVOCATE_ROLES } from "utils/roles";
import AddChargeFeedbackModal from "./AddChargeFeedbackModal";
import AddChargeRegistrationModal from "./AddChargeRegistrationModal";
import UpdateChargeDocModal from "./UpdateChargeDocModal";

interface ChargeProps {
  investigationData: Investigation;
  complaintData: Complaints;
  onInvestigationRefresh: any;
  onComplaintRefresh?: any;
}

export default function ChargeDocumentCardAdvocate({
  investigationData,
  complaintData,
  onInvestigationRefresh,
  onComplaintRefresh,
}: ChargeProps) {
  const { t } = useTranslation();
  const { showToast } = useToast();

  const canCreateChargeFeedback = useHasRole([
    ADVOCATE_ROLES.INSPECTION_COORDINATOR,
    ADVOCATE_ROLES.INSPECTION_DIRECTOR,
  ]);
  const canViewChargeFeedback = useHasRole([
    ADVOCATE_ROLES.INSPECTION_DIRECTOR,
    ADVOCATE_ROLES.INSPECTION_COORDINATOR,
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
  ]);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  const canRegisterChargeDoc = useHasRole([
    ADVOCATE_ROLES.INSPECTION_PROSECUTOR,
  ]);
  const canUpdateChargeDoc = useHasRole([ADVOCATE_ROLES.INSPECTION_PROSECUTOR]);

  // const [chargeFeedback, setChargeFeedback] = useState("");
  // const [councilChargeFeedback, setCouncilChargeFeedback] = useState<any>([]);
  // const [error, setError] = useState("");
  // const [loading, setLoading] = useState(true);
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  const [forwardReturned, setForwardReturned] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isUpdateOpen, setIsUpdateOpen] = useState(false);

  // const loadChargeFeedback = useCallback(async () => {
  //   if (!investigationData || !investigationData.uu_id) return;

  //   setLoading(true);
  //   try {
  //     const resData = await fetchChargeFeedbackByInvestigationId(
  //       investigationData.uu_id
  //     );
  //     if (resData) {
  //       setChargeFeedback(
  //         resData
  //           // ?.filter(obj => obj?.investigation === investigationData.uu_id)
  //           ?.slice()
  //           ?.reverse()[0]?.comment || ""
  //       );
  //     }
  //   } catch (err) {
  //     setError("Failed to load investigation.");
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [investigationData]);

  // const loadCouncilChargeFeedback = useCallback(async () => {
  //   if (!investigationData || !investigationData.uu_id) return;

  //   setLoading(true);
  //   try {
  //     const resData = await fetchChargeFeedbackByCouncilByInvestigationId(
  //       investigationData.uu_id
  //     );
  //     if (resData) {
  //       setCouncilChargeFeedback(
  //         resData
  //           // ?.filter(obj => obj?.investigation === investigationData.uu_id)
  //           ?.sort(
  //             (a: any, b: any) =>
  //               new Date(b?.createdAt ?? "").getTime() -
  //               new Date(a?.createdAt ?? "").getTime()
  //           )
  //           ?.slice()
  //           ?.reverse()
  //       );
  //     }
  //   } catch (err) {
  //     setError("Failed to load investigation.");
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [investigationData]);

  // useEffect(() => {
  //   loadChargeFeedback();
  // }, [investigationData]);

  // useEffect(() => {
  //   loadCouncilChargeFeedback();
  // }, [investigationData]);

  const handleForwardReturned = async () => {
    setIsSubmitLoading(true);

    try {
      const resData = await editComplaint({
        ...complaintData,
        status: COMPLIANT_STATUS.DRAFT_CHARGE,
      });

      if (
        resData &&
        investigationData?.status ===
          INVESTIGATION_STATUS.FORWARDED_TO_REGISTRAR
      ) {
        await editComplaint({
          ...(complaintData as Complaints),
          has_councile: true,
          status: COMPLIANT_STATUS.COUNCIL_OFFICE,
        });
      }

      onComplaintRefresh && onComplaintRefresh();
      setForwardReturned(false);
      showToast(t("sent"), "success");
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
    } finally {
      setIsSubmitLoading(false);
    }
  };

  if (
    !investigationData ||
    (investigationData &&
      !(
        investigationData?.investigation_documents ||
        investigationData?.documents ||
        []
      )?.filter((i) => i?.document_type === "charge_document")?.length &&
      !investigationData?.charge_summary)
  )
    return null;

  const chargeDocuments = (
    investigationData?.investigation_documents ||
    investigationData?.documents ||
    []
  )?.filter((i) => i?.document_type === "charge_document");
  // const investigationFiles = (
  //   investigationData?.investigation_documents ||
  //   investigationData?.documents ||
  //   []
  // )?.filter((i) => i?.document_type === "investigation_file");

  // Sort charge documents by created_at DESC and split into latest + history
  const sortedChargeDocs = [...(chargeDocuments || [])].sort(
    (a: any, b: any) =>
      new Date(b?.created_at ?? "").getTime() -
      new Date(a?.created_at ?? "").getTime(),
  );
  const latestChargeDoc = sortedChargeDocs?.[0];
  const chargeDocHistory = sortedChargeDocs?.slice(1) || [];

  return (
    <div className="mb-8">
      <div className="mx-auto bg-white border rounded-xl  overflow-hidden mb-4">
        <div className="p-5">
          <h1 className="text-1xl font-bold text-gray-800 mb-3">
            {t("chargeDocument")}
          </h1>
          {latestChargeDoc && (
            <div className="mb-4">
              <h2 className="text-sm font-semibold text-gray-700 mb-2">
                Latest
              </h2>
              <DocumentViewerModal
                documents={[latestChargeDoc] as any}
                baseUrl={`${process.env.REACT_APP_API_BASE_URL}prosecutor-decipiline/investigation-documents/document`}
                layout="list"
              />
            </div>
          )}

          <div className="mb-6 ">
            <hr />

            {investigationData?.date && (
              <div className="w-full flex flex-wrap items-center justify-between gap-4 my-3">
                <p className="block  text-gray-600">{t("registeredDate")}</p>
                <p className="block  text-black font-medium">
                  {investigationData?.date || "-"}
                </p>
              </div>
            )}

            {investigationData?.registration_number && (
              <div className="w-full flex flex-wrap items-center justify-between gap-4 my-3">
                <p className="block  text-gray-600">{t("registeredNumber")}</p>
                <p className="block  text-black font-medium">
                  {investigationData?.registration_number || "-"}
                </p>
              </div>
            )}
          </div>

          {/* Summary Desc */}
          <div className="my-3">
            <h1 className="text-1xl font-bold text-gray-800 mb-1">
              {t("chargeSummary")}
            </h1>
            <p className="text-gray-600 leading-relaxed">
              {investigationData?.charge_summary || "-"}
            </p>
          </div>

          <div className="my-3">
            <h1 className="text-1xl font-bold text-gray-800 mb-1">
              {t("articleOfCharge")}
            </h1>
            <p className="text-gray-600 leading-relaxed">
              {investigationData?.charge_article || "-"}
            </p>
          </div>

          <hr />

          {/* History */}
          {chargeDocHistory && chargeDocHistory.length > 0 && (
            <div className="mt-2">
              <h2 className="text-sm font-semibold text-gray-700 mb-2">
                History
              </h2>
              <DocumentViewerModal
                documents={chargeDocHistory as any}
                baseUrl={`${process.env.REACT_APP_API_BASE_URL}prosecutor-decipiline/investigation-documents/document`}
                layout="list"
              />
            </div>
          )}

          {canViewChargeFeedback &&
            investigationData?.director_feedbackshargedocument
              ?.sort(
                (a: any, b: any) =>
                  new Date(b?.created_at ?? "").getTime() -
                  new Date(a?.created_at ?? "").getTime(),
              )
              ?.map((feedback, index) => (
                <div className="bg-gray-700 p-5 rounded-md mt-3">
                  <div className="flex items-center justify-between mb-2">
                    <p className="font-medium text-white">
                      {t("chargeFeedback")} {index + 1}
                    </p>
                    {index === 0 && (
                      <StatusChip
                        status={
                          investigationData?.feedback_status_charge_docu ?? null
                        }
                      />
                    )}
                  </div>
                  <p className="text-sm text-gray-100 leading-relaxed">
                    {feedback?.comment || ""}
                  </p>
                </div>
              ))}

          {investigationData?.councilwritercharge_docs?.map((feedback) => (
            <div className="my-3">
              <h1 className="text-1xl font-bold text-gray-800 mb-1">
                {t("councilChargeFeedback")}
              </h1>
              <p className="text-gray-600 leading-relaxed">
                {feedback?.comment || "-"}
              </p>
            </div>
          ))}

          {canCreateChargeFeedback &&
            investigationData &&
            complaintData.status === COMPLIANT_STATUS.RETURNED && (
              <button
                className="w-full bg-[#5f5f5f] hover:bg-gray-800 border border-white text-white py-2 rounded-lg mt-2"
                onClick={() => setForwardReturned(true)}
              >
                Forward
              </button>
            )}

          {canCreateChargeFeedback &&
            investigationData &&
            investigationData?.feedback_status_charge_docu !==
              FEEDBACK_TYPE?.APPROVED && (
              <button
                className="w-full bg-[#5f5f5f] hover:bg-gray-800 border border-white text-white py-2 rounded-lg mt-2"
                onClick={() => setIsFeedbackOpen(true)}
              >
                {t("addFeedback")}
              </button>
            )}
        </div>
      </div>
      {canRegisterChargeDoc &&
        investigationData?.director_feedbackshargedocument?.some(
          (feedback) => feedback.comment !== null,
        ) &&
        investigationData?.status === INVESTIGATION_STATUS.ON_CHARGE &&
        investigationData?.feedback_status_charge_docu === "Approve" &&
        !investigationData?.registration_number && (
          <div className="text-right">
            <button
              className="bg-black text-white px-14 py-2 rounded-md hover:bg-gray-800"
              type="submit"
              onClick={() => setIsOpen(true)}
            >
              {t("addRegistrationNo")}
            </button>
          </div>
        )}

      {canUpdateChargeDoc &&
        (investigationData?.status ===
          INVESTIGATION_STATUS.FORWARDED_TO_REGISTRAR ||
          investigationData?.status ===
            INVESTIGATION_STATUS.BACK_TO_PROSECUTOR) &&
        investigationData?.registration_number && (
          <div className="text-right">
            <button
              className="bg-black text-white px-14 py-2 rounded-md hover:bg-gray-800"
              type="submit"
              onClick={() => setIsUpdateOpen(true)}
            >
              {t("updateChargeDoc")}
            </button>
          </div>
        )}

      {investigationData && (
        <AddChargeFeedbackModal
          isOpen={isFeedbackOpen}
          setIsOpen={setIsFeedbackOpen}
          complaintData={complaintData}
          investigationData={investigationData}
          onRefresh={onInvestigationRefresh}
          returned={complaintData.status === COMPLIANT_STATUS.RETURNED}
        />
      )}

      {investigationData && latestChargeDoc && (
        <AddChargeRegistrationModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          complaintData={complaintData}
          investigationData={investigationData}
          onRefresh={onInvestigationRefresh}
          latestChargeDoc={latestChargeDoc}
        />
      )}

      {investigationData && (
        <UpdateChargeDocModal
          isOpen={isUpdateOpen}
          setIsOpen={setIsUpdateOpen}
          complaintData={complaintData}
          investigationData={investigationData}
          onRefresh={onInvestigationRefresh}
        />
      )}

      <ConfirmationModal
        isOpen={forwardReturned}
        onCancel={() => setForwardReturned(false)}
        onConfirm={handleForwardReturned}
        isLoading={isSubmitLoading}
      />
    </div>
  );
}
